// assets
import {
    AppstoreOutlined,
    AppstoreAddOutlined,
    ClusterOutlined,
    PlusCircleOutlined,
    ShoppingCartOutlined,
} from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    AppstoreOutlined,
    AppstoreAddOutlined,
    ClusterOutlined,
    PlusCircleOutlined,
    ShoppingCartOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const partner: NavGroupType = {
    id: 'group-partner',
    title: 'menu.partner.title',
    type: 'group',
    children: {} as { [key: string]: any },
    disabled: {
        qlive_partner_network_list: {
            id: '0-network',
            title: 'menu.partner.items.network',
            type: 'item',
            url: '/network',
            icon: icons.ClusterOutlined,
            breadcrumbs: false,
        },
        qlive_partner_partner_list: {
            id: '1-partner',
            title: 'menu.partner.items.partner',
            type: 'item',
            url: '/partner',
            icon: icons.AppstoreOutlined,
            breadcrumbs: false,
        },
        qlive_partner_order_list: {
            id: '2-order',
            title: 'menu.partner.items.order',
            type: 'item',
            url: '/order',
            icon: icons.ShoppingCartOutlined,
            breadcrumbs: false,
        },
    },
};

export default partner;
